window.addEventListener("load", function () {
    let news = this.document.querySelectorAll('.js-hompage-news');

    for(let newsBlock of news) {
        let btn = newsBlock.querySelector('.js-hompage-news-more');
        let text = newsBlock.querySelector('.js-hompage-news-text');

        btn.addEventListener('click', function(e) {
            e.preventDefault();

            if(text.classList.contains('upsd-bl-one-news__bigtext_open')) {
                text.classList.remove('upsd-bl-one-news__bigtext_open');
                btn.innerHTML = 'Смотреть';
            } else {
                text.classList.add('upsd-bl-one-news__bigtext_open');
                btn.innerHTML = 'Скрыть';
            }
        })
    }
});